import * as React from 'react'

export const ChartIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.625 3.28125L11.625 7.28125C11.25 7.59375 10.75 7.59375 10.375 7.3125L7 4.78125L2.625 8.28125C2.1875 8.625 1.5625 8.5625 1.21875 8.125C0.875 7.71875 0.9375 7.0625 1.375 6.71875L6.375 2.71875C6.71875 2.4375 7.21875 2.4375 7.59375 2.71875L10.9688 5.25L15.375 1.71875C15.7812 1.375 16.4375 1.46875 16.7812 1.875C17.125 2.3125 17.0312 2.9375 16.625 3.28125ZM6 8.5C6 7.96875 6.4375 7.5 7 7.5C7.53125 7.5 8 7.96875 8 8.5V14.5C8 15.0625 7.53125 15.5 7 15.5C6.4375 15.5 6 15.0625 6 14.5V8.5ZM2 11.5C2 10.9688 2.4375 10.5 3 10.5C3.53125 10.5 4 10.9688 4 11.5V14.5C4 15.0625 3.53125 15.5 3 15.5C2.4375 15.5 2 15.0625 2 14.5V11.5ZM11 9.5C11.5312 9.5 12 9.96875 12 10.5V14.5C12 15.0625 11.5312 15.5 11 15.5C10.4375 15.5 10 15.0625 10 14.5V10.5C10 9.96875 10.4375 9.5 11 9.5ZM14 8.5C14 7.96875 14.4375 7.5 15 7.5C15.5312 7.5 16 7.96875 16 8.5V14.5C16 15.0625 15.5312 15.5 15 15.5C14.4375 15.5 14 15.0625 14 14.5V8.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
